export default __webpack_public_path__ + "static/media/arearug3.a861fbb8.jpg";